import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { memo } from 'react';
import { Field } from 'redux-form';
import { formGroupCommonPropTypes, formGroupCommonDefaultProps } from "./FormGroupCommonPropTypes";
import RenderRadio from "./Renderers/RenderRadio";
var FormGroupRadio = function FormGroupRadio(props) {
  var value = props.value;
  return /*#__PURE__*/React.createElement(Field, _extends({
    component: RenderRadio,
    props: {
      value: value
    }
  }, props));
};
FormGroupRadio.propTypes = _objectSpread({}, formGroupCommonPropTypes);
FormGroupRadio.defaultProps = _objectSpread({}, formGroupCommonDefaultProps);
export default /*#__PURE__*/memo(FormGroupRadio);